import { useState, useEffect } from "react";
// Chakra imports
import {
  Box,
  Icon,
  SimpleGrid,
  useColorModeValue,
} from "@chakra-ui/react";
import {
  MdBarChart,
} from "react-icons/md";

// Custom components
import MiniStatistics from "../../../components/card/MiniStatistics";
import IconBox from "../../../components/icons/IconBox";
import { LoadingSpinner } from "../../../constants/helper";
import { dashboardAirlineLuggageCount } from "./hook";

export default function UserReports() {
  // Chakra Color Mode
  const brandColor = useColorModeValue("brand.500", "white");
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  const [loading, setLoading] = useState(true); // Loading state to track fetching status
  const [airlinesLuggageCount, setAirlinesLuggageCount] = useState([]); // Ensure default state is an array

  const fetchAirlinesLuggageCount = async () => {
      setLoading(true);
      try {
          let res = await dashboardAirlineLuggageCount();
          if (res.success) {
              setAirlinesLuggageCount(res.data?.formattedDashboardAirline || []);
          }
      } catch (error) {
          console.error("Error fetching luggages:", error);
      } finally {
          setLoading(false); // Set loading to false after fetching is complete
      }
  };
  useEffect(() => {
      fetchAirlinesLuggageCount(); // Call the async function
  }, []);

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid
        columns={{ sm: 1, md: 2, lg: 2 }}
        gap='20px'
        mb='20px'>
          {
            loading ?
                <LoadingSpinner />
                :
                airlinesLuggageCount && airlinesLuggageCount?.map((luggage) => {
                  return(
                    <MiniStatistics
                      startContent={
                        <IconBox
                          w='56px'
                          h='56px'
                          bg={boxBg}
                          icon={
                            <Icon w='32px' h='32px' as={MdBarChart} color={brandColor} />
                          }
                        />
                      }
                      name={luggage?.airlineName}
                      value={luggage?.luggageCount}
                    />
                  )
                })
          }
      </SimpleGrid>
    </Box>
  );
}
